export default __webpack_public_path__ + "static/media/ibusinesslogo.0db9f3d1.png";